import React from 'react';

interface YouTubeIconProps {
  className?: string;
}

const YouTubeIcon: React.FC<YouTubeIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-youtube', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default YouTubeIcon;
